import { useState } from 'react';
import { Autocomplete, Checkbox, FormControlLabel, TextField } from '@mui/material';

import type { NodeItem, ParentNode, TestGroupOptions } from '@models/flows';
import { getLeftOverTestGroupsOptions, normalizeTestGroupValue } from '@utils/flows';

type ErrorNodeConfigProps = {
  parentNode: ParentNode;
  currentNode: NodeItem;
  onChange: (data: NodeItem) => void;
};

function TestGroupsNodeConfiguration({ parentNode, currentNode, onChange }: ErrorNodeConfigProps) {
  const [isAllSelected, setIsAllSelected] = useState(currentNode.isAllSelected || false);

  if (!currentNode) return null;

  const leftOverOptions = getLeftOverTestGroupsOptions(parentNode, currentNode);

  const handleChange = (testGroupOptions: TestGroupOptions[]) => {
    const selectedGroups = testGroupOptions.map((option) => option.group);
    const returnValue: number[] = selectedGroups;

    onChange({
      ...currentNode,
      value: returnValue,
    });
  };

  const handleSelectAllChange = (selectAll: boolean) => {
    setIsAllSelected(selectAll);

    if (selectAll) {
      onChange({
        ...currentNode,
        value: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        isAllSelected: true,
      });
      return;
    }

    onChange({
      ...currentNode,
      value: [],
      isAllSelected: false,
    });
  };

  return (
    <>
      <FormControlLabel
        label="Select all test groups"
        control={
          <Checkbox
            checked={isAllSelected}
            onChange={() => handleSelectAllChange(!isAllSelected)}
          />
        }
      />
      <Autocomplete
        multiple
        id="tags-outlined"
        options={leftOverOptions}
        getOptionLabel={(option) => option.title}
        filterSelectedOptions
        disableCloseOnSelect
        disabled={isAllSelected}
        value={normalizeTestGroupValue(currentNode.value)}
        onChange={(_, value) => {
          handleChange(value);
        }}
        renderInput={(params) => <TextField {...params} label="Groups" />}
        slotProps={{
          popper: {
            style: { zIndex: 2000 },
          },
        }}
      />
    </>
  );
}

export default TestGroupsNodeConfiguration;
